export default __webpack_public_path__ + "static/media/logo-p.313b7330.svg";